var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tmap"},[_c('h3',{staticClass:"marginBottom10"},[_vm._v("停车区电子围栏")]),_c('div'),_c('div',{ref:"tmap",staticClass:"map marginTop20",staticStyle:{"width":"100%","height":"600px"},attrs:{"id":"darkMap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }